import LockIcon from "@mui/icons-material/Lock";
import Grid from "@mui/material/Grid";

const LockIconComponent = () => {
    return (
        <Grid
            item
            xs={1}
            style={{
                marginTop: "23px",
                paddingLeft: "20px",
            }}
        >
            <LockIcon style={{ height: "20px" }} />
        </Grid>
    );
};

export default LockIconComponent;
